<template>
  <router-view></router-view>
</template>

<script>
export default {
  watch: {
    '$store.getters.isNightMode': {
      immediate: true,
      handler(isNightMode) {
        this.$vuetify.theme.dark = isNightMode;
      }
    }
  }
};
</script>
